<script setup lang="ts">
import { getCurrentLocale } from '@/i18n';
import { getTextVariant } from '@/utils/stringUtils';

interface Props {
  infoData: any;
}
defineProps<Props>();

const currentLanguage = getCurrentLocale();
</script>
<template>
  <div class="cruise-info-wrapper">
    <div class="lead-option">{{ $t('worksheet.cruise') }}</div>
    <div class="font-bold flex justify-content-between flex-wrap lg:flex-nowrap">
      <div>
        <div class="cruise_line flex gap-3 mt-2 mb-2">
          <div class="min-w-label">{{ $t('worksheet.cruise_line') }}:</div>
          <div class="font-normal">{{ infoData.cruiseLine }}</div>
        </div>
        <div class="cruise_ship flex gap-3 mb-2">
          <div class="min-w-label">{{ $t('worksheet.cruise_ship') }}:</div>
          <div class="font-normal">{{ infoData.cruiseShip }}</div>
        </div>
        <div class="cruise-sailing font-bold">
          <div class="flex gap-3 mb-2">
            <div class="min-w-label">{{ $t('worksheet.cruise_sailing') }}:</div>
            <div class="font-normal">{{ infoData.cruiseSailling }}</div>
          </div>
        </div>
        <div class="category font-bold">
          <div class="flex gap-3 mb-2">
            <div class="min-w-label">{{ $t('common.category') }}:</div>
            <div class="font-normal">{{ getTextVariant(currentLanguage, infoData.categoryEn, infoData.categoryFr) }}</div>
          </div>
        </div>
      </div>
      <div class="flex flex-column align-items-end">
        <div class="adults font-bold mb-2 mt-2">
          <div class="flex">
            <div class="min-w-label">{{ $t('common.adults') }}:</div>
            <div class="font-normal w-6rem">{{ infoData.adults ?? 0 }}</div>
          </div>
        </div>
        <div class="child font-bold mb-2">
          <div class="flex">
            <div class="min-w-label">{{ $t('common.children') }}:</div>
            <div class="font-normal w-6rem">{{ infoData.children ?? 0 }}</div>
          </div>
        </div>
        <div class="infant font-bold mb-2">
          <div class="flex">
            <div class="min-w-label">{{ $t('common.infant') }}:</div>
            <div class="font-normal w-6rem">{{ infoData.infant ?? 0 }}</div>
          </div>
        </div>
        <div class="cabins font-bold mb-2">
          <div class="flex">
            <div class="min-w-label"># {{ $t('worksheet.cabins') }}:</div>
            <div class="font-normal w-6rem">{{ infoData.cabinNo ?? 0 }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
